import { useQuery } from '@tanstack/react-query';
import httpService from 'services/http';
import { systemKeys } from './keys';

type UseSystemOptions = {
  enabled?: boolean;
};

export const useSystem = (systemId?: number, options?: UseSystemOptions) => {
  return useQuery({
    queryKey: systemKeys.detail(systemId),
    queryFn: async () => {
      if (!systemId) throw new Error('No system id');
      const response = await httpService.get(`systems/${systemId}/`, {}, 'json', true, 'v2');
      return response.data;
    },
    enabled: (options?.enabled ?? true) && !!systemId,
  });
};

export default useSystem;
